import axios from 'axios'
import {Notification,  MessageBox, Message ,Loading } from 'element-ui'
import errorCode from '@/utils/errorCode'
import cache from '@/plugins/cache'
import { getToken } from '@/utils/auth'
import { tansParams } from "@/utils/tools";

let messageInstance = null;

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    // const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    const isRepeatSubmit = true;
    if (getToken() && !isToken) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
      const requestObj = {
        url: config.url,
        data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
        time: new Date().getTime()
      }
      const sessionObj = cache.session.getJSON('sessionObj')
      if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
        cache.session.setJSON('sessionObj', requestObj)
      } else {
        const s_url = sessionObj.url;                  // 请求地址
        const s_data = sessionObj.data;                // 请求数据
        const s_time = sessionObj.time;                // 请求时间
        const interval = 2000;
        if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
          const message = '数据正在处理，请勿重复提交';
          console.warn(`[${s_url}]: ` + message)
          //弹出提示
          return Promise.reject(new Error(message))
        } else {
          cache.session.setJSON('sessionObj', requestObj)
        }
      }
    }
    return config
  },error => {
   return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.message || errorCode['default']
  // 二进制数据则直接返回
  if(res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer'){
    return res.data
  }
  if (code === 401) {
    showMessage({
      message: 'Interface request data is limited',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(new Error('Interface request data is limited'))
  } else if (code === 500) {
    showMessage({
      message: msg,
      type: 'error'
    })
    return Promise.reject(new Error(msg))
  } else if (code !== 200) {
    Notification.error({
      title: msg
    })
    return Promise.reject('error')
  } else {
    return res
  }
},
error => {
  let { message } = error;
  const status = error.response ? error.response.status : null;
  if (status === 401) {
    // 处理 HTTP 状态码 401
    showMessage({
      message: '接口没有权限',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject('接口没有权限')
  }
  if (message == "Network Error") {
    message = "Network connection is abnormal. Please try again later";
  }
  else if (message.includes("timeout")) {
    message = "The service or network is busy. Please refresh and try again later";
  }
  else if (message.includes("Request failed with status code")) {
    message = "Service upgrade is in progress. Please try again later!";
  }
  else if(message.includes("空指针")){
    message = "The service or network is busy. Please refresh and try again later";
  }
  showMessage({
    message: message,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
})

function showMessage(message) {
  // 如果当前没有 Message 显示，则创建一个新的 Message
  if (!messageInstance) {
    messageInstance = Message(message);
    // 在 Message 关闭后，将 messageInstance 设置为 null
    messageInstance.onClose = function() {
      messageInstance = null;
    };
  }
}

export default service
